import { Box, Grid } from '@mui/material';
import TaskInfoIcon from 'assets/icons/open-task-info-icon.svg?react';
import DangerIcon from 'assets/icons/danger-icon.svg?react';
import ApproveIcon from 'assets/icons/agreement-status/approved-status-icon.svg?react';

type Props = {
  message: string;
  messageType: 'success' | 'info' | 'warning';
  hasBorder: boolean;
};

export const MessageBox = ({ message, messageType, hasBorder }: Props) => {
  const borderStyle = {
    display: 'flex',
    padding: '1.5em',
    border: '1px solid blue',
    backgroundColor: '#EAF2FF',
    mt: 0.5,
  };
  const defaultStyle = { marginTop: '-1em', padding: '0.5em' };

  const renderIconBasedOnMessageType = () => {
    switch (messageType) {
      case 'success':
        return <ApproveIcon />;
      case 'info':
        return <TaskInfoIcon />;
      case 'warning':
        return <DangerIcon />;
    }
  };

  return (
    <Box data-testid="message-box" sx={hasBorder ? borderStyle : defaultStyle}>
      {message && (
        <Grid container sx={{ display: 'flex', padding: '1.5em' }}>
          <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
            <Grid item xs={1}>
              {renderIconBasedOnMessageType()}
            </Grid>
            <Grid item xs={11}>
              <Grid container>
                {' '}
                <div dangerouslySetInnerHTML={{ __html: message }} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};
